import React from "react"
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
} from "@chakra-ui/react"
import TOS from "./TOS"

export default function TOSModal({ isOpen, onClose }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} variant="standard">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Terms of Service</ModalHeader>
        <ModalCloseButton onClick={onClose} />
        <ModalBody>
          <TOS />
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}
